/** Sends contact messages through the existing EmailJS Gmail service/template. */

export type ContactPayload = {
  name: string
  email: string
  subject: string
  message: string
  lang: 'EN' | 'DE'
  website: string
  startedAt: number
}

export type ContactResult = { success: true } | { success: false; error: string }

const serviceId = 'softmaze_emailer'
const templateId = 'template_jmugv9k'
const publicKey = import.meta.env.VITE_EMAILJS_PUBLIC_KEY

export async function sendContactMessage(payload: ContactPayload): Promise<ContactResult> {
  if (!publicKey) return { success: false, error: 'not_configured' }
  if (payload.website || Date.now() - payload.startedAt < 1500) {
    return { success: false, error: 'invalid_submission' }
  }

  const data = new FormData()
  data.append('service_id', serviceId)
  data.append('template_id', templateId)
  data.append('user_id', publicKey)
  data.append('from_name', payload.name.trim())
  data.append('from_email', payload.email.trim())
  data.append('subject', payload.subject.trim())
  // The template displays {{message}} and uses {{from_email}} as Reply-To.
  // Include the address in the body too, so it stays visible in forwarded mail.
  data.append('message', `Email: ${payload.email.trim()}\n\n${payload.message.trim()}`)
  data.append('time', new Intl.DateTimeFormat(payload.lang === 'DE' ? 'de-AT' : 'en-AT', {
    dateStyle: 'medium', timeStyle: 'short', timeZone: 'Europe/Vienna',
  }).format(new Date()))

  try {
    const res = await fetch('https://api.emailjs.com/api/v1.0/email/send-form', {
      method: 'POST',
      body: data,
    })
    if (res.ok) return { success: true }
    return { success: false, error: `http_${res.status}` }
  } catch {
    return { success: false, error: 'network' }
  }
}
